import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

// 初始化 dayjs 插件
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(utc);

export const formatTime = (
  timestamp: number | Date | string,
  format: string = "MMM DD, YYYY",
): string => {
  return dayjs(timestamp).format(format);
};

export const formatDurationToMilliseconds = (seconds: number): string => {
  return dayjs.duration(Math.floor(seconds * 1000)).format("mm:ss.SSS");
};

export const formatDuration = (
  seconds: number,
  format: string = "mm:ss",
): string => {
  return dayjs.duration(Math.floor(seconds * 1000)).format(format);
};

export const formatRelativeTime = (
  timestamp: number | Date | string,
): string => {
  return dayjs(timestamp).fromNow();
};

/**
 * 将 UTC 时间字符串转换为本地时间
 * @param utcString UTC 时间字符串 (e.g., "2026-02-05 02:56:12")
 * @returns 本地时间 dayjs 对象
 */
export const utcToLocal = (utcString: string) => {
  return dayjs.utc(utcString).local();
};

/**
 * 将 UTC 时间字符串格式化为本地时间字符串
 */
export const formatUtcToLocal = (
  utcString: string,
  format: string = "YYYY-MM-DD HH:mm:ss",
): string => {
  if (!utcString) return "";
  return utcToLocal(utcString).format(format);
};
